import { useState, useRef, useEffect } from "react";
import { Row, Col } from "antd";
import "../../styles/home/home.css";
import ItemDetailsCard from "../../components/home/ItemDetailsCard";
import SummaryCard from "../../components/home/SummaryCard";
import PaymentCard from "../../components/home/payment/PaymentCard";
import calculateTotalAmount from "../../functions/Common/calculateTotalAmount";
import useUploadFakeImage from "../../functions/Fake/uploadFakeImage";
import useGetFakeAIImage from "../../functions/Fake/getFakeAIImage";
import useGetCategory from "../../functions/Category/getCategory";
import useGetMerchantSST from "../../functions/Merchant/getMerchantSST";
import useGetMerchantExtraCharges from "../../functions/Merchant/getMerchantExtraCharges";

const PLATE = {
  image_id: null,
  ai_image_data: null,
  items: [],
};

const timeout_duration = 10;
const BYPASS_IMAGE = false;

function HomePage() {
  const itemDetailsCardRef = useRef();

  const [plates, setPlates] = useState([PLATE]);
  const [selectedPlateIndex, setSelectedPlateIndex] = useState(0);
  const [activeTabKey, setActiveTabKey] = useState(1);
  const [selectedItemKey, setSelectedItemKey] = useState();
  const [isShowPayment, setIsShowPayment] = useState(false);
  const [selectedSubCategory, setSelectedSubCategory] = useState();
  const [isDisableButton, setIsDisableButton] = useState({
    cancel_order_btn: false,
    pay_btn: false,
    delete_plate_btn: false,
    add_plate_btn: false,
    add_item_btn: false,
    takeaway_checkbox: false,
    delete_item_btn: false,
  });
  const [receiptPrice, setReceiptPrice] = useState({
    total: 0,
    sst: 0,
    subtotal: 0,
    change: null,
    round_adj: null,
    cash: null,
    takeaway_fee: 0,
  });
  const [extraChangesOptions, setExtraChargesOptions] = useState({
    takeaway_fee: false,
  });
  const [connectDevice, setConnectDevice] = useState(null);

  const { category, categoryLoading, getCategory } = useGetCategory();
  const { sstInfo, getMerchantSST } = useGetMerchantSST();
  const { extraCharges, getMerchantExtraCharges } =
    useGetMerchantExtraCharges();

  const { uploadFakeImage, uploadedImageId, setUploadedImageId } =
    useUploadFakeImage();
  const { getFakeAIImage } = useGetFakeAIImage();

  const getFakePlates = (cloned_plates) => {
    setPlates(cloned_plates);
    setIsDisableButton((prev) =>
      Object.fromEntries(Object.keys(prev).map((key) => [key, false]))
    );
    setUploadedImageId(null);
    setActiveTabKey(2);
  };

  const callGetFakeImage = (image_id) => {
    getFakeAIImage(
      image_id,
      timeout_duration,
      plates,
      selectedPlateIndex,
      getFakePlates
    );
  };

  const createFakeImage = () => {
    if (!uploadedImageId) {
      uploadFakeImage("", timeout_duration, callGetFakeImage);
    } else {
      callGetFakeImage(uploadedImageId);
    }
  };

  const onPaymentSuccessReset = () => {
    setPlates([]);
    setIsShowPayment(false);
    setSelectedPlateIndex(0);
    setSelectedItemKey(null);
    setActiveTabKey(1);
    setReceiptPrice({
      total: 0,
      sst: 0,
      subtotal: 0,
      change: null,
      round_adj: null,
      cash: null,
      takeaway_fee: 0,
    });
    if (BYPASS_IMAGE) createFakeImage();
  };

  const onReloadDetails = () => {
    getCategory();
    getMerchantSST();
    getMerchantExtraCharges();
  };

  const handleAlaCartOrder = () => {
    createFakeImage();
  };

  useEffect(() => {
    let amount = calculateTotalAmount(
      plates,
      sstInfo,
      extraCharges,
      extraChangesOptions
    );
    setReceiptPrice((prev) => ({
      ...prev,
      total: amount.total,
      subtotal: amount.subtotal,
      sst: amount.sst,
    }));

    if (BYPASS_IMAGE)
      if (plates.length == 0 || plates[plates.length - 1]?.image_id == null) {
        createFakeImage();
      }
  }, [plates]);

  useEffect(() => {
    window.scrollTo(0, 500);
  }, []);

  useEffect(() => {
    let amount = calculateTotalAmount(
      plates,
      sstInfo,
      extraCharges,
      extraChangesOptions
    );
    setReceiptPrice((prev) => ({
      ...prev,
      total: amount.total,
      subtotal: amount.subtotal,
      sst: amount.sst,
      takeaway_fee: extraChangesOptions.takeaway_fee
        ? extraCharges.takeaway_fee
        : 0,
    }));
  }, [extraChangesOptions]);

  return (
    <Row gutter={[10, 10]} style={{ height: "100%" }}>
      <Col span={16} style={{ height: "100%" }}>
        {!isShowPayment ? (
          <ItemDetailsCard
            plates={plates}
            setPlates={setPlates}
            itemDetailsCardRef={itemDetailsCardRef}
            selectedPlateIndex={selectedPlateIndex}
            activeTabKey={activeTabKey}
            setActiveTabKey={setActiveTabKey}
            selectedItemKey={selectedItemKey}
            setSelectedItemKey={setSelectedItemKey}
            category={category}
            categoryLoading={categoryLoading}
            setIsDisableButton={setIsDisableButton}
            selectedSubCategory={selectedSubCategory}
            setSelectedSubCategory={setSelectedSubCategory}
            onReloadDetails={onReloadDetails}
            handleAlaCartOrder={handleAlaCartOrder}
          />
        ) : (
          <PaymentCard
            plates={plates}
            setIsShowPayment={setIsShowPayment}
            onPaymentSuccessReset={onPaymentSuccessReset}
            setIsDisableButton={setIsDisableButton}
            receiptPrice={receiptPrice}
            setReceiptPrice={setReceiptPrice}
            itemDetailsCardRef={itemDetailsCardRef}
            setExtraChargesOptions={setExtraChargesOptions}
            connectDevice={connectDevice}
            setConnectDevice={setConnectDevice}
          />
        )}
      </Col>
      <Col span={8}>
        <SummaryCard
          plates={plates}
          setPlates={setPlates}
          itemDetailsCardRef={itemDetailsCardRef}
          selectedPlateIndex={selectedPlateIndex}
          setSelectedPlateIndex={setSelectedPlateIndex}
          setActiveTabKey={setActiveTabKey}
          selectedItemKey={selectedItemKey}
          setSelectedItemKey={setSelectedItemKey}
          setIsShowPayment={setIsShowPayment}
          isDisableButton={isDisableButton}
          setIsDisableButton={setIsDisableButton}
          receiptPrice={receiptPrice}
          sstInfo={sstInfo}
          setSelectedSubCategory={setSelectedSubCategory}
          setExtraChargesOptions={setExtraChargesOptions}
          extraChangesOptions={extraChangesOptions}
          extraCharges={extraCharges}
        />
      </Col>
    </Row>
  );
}

export default HomePage;
